import React, { useEffect, useContext, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { FiCheckCircle, FiLoader, FiAlertCircle } from "react-icons/fi";
import { CartContext } from "../context/CartProvider";
import axios from "axios";

const OrderSuccess = () => {
  const context = useContext(CartContext);
  // Safe destructuring with fallback
  const clearCart = context?.clearCart || (() => console.warn("CartContext missing"));

  const location = useLocation();
  const [status, setStatus] = useState("verifying"); // verifying, success, failed
  const [message, setMessage] = useState("Verifying your payment...");

  useEffect(() => {
    let isMounted = true;

    const verifyPayment = async () => {
      console.log("Verifying payment...", location.search);
      const searchParams = new URLSearchParams(location.search);
      const sessionId = searchParams.get("session_id");

      if (!sessionId) {
        console.log("No session ID found, assuming success navigation.");
        if (isMounted) {
          setStatus("success");
          clearCart();
          localStorage.removeItem("checkoutFormSimplified");
          setMessage("Your order has been placed successfully.");
        }
        return;
      }

      try {
        const baseUrl = process.env.REACT_APP_API_URL || "http://localhost:8080/api/";
        console.log("Calling verify-session endpoint:", baseUrl);

        const response = await axios.post(`${baseUrl}order/verify-session`, {
          session_id: sessionId,
        });

        console.log("Verify response:", response.data);

        if (isMounted) {
          if (response.data.success) {
            setStatus("success");
            clearCart();
            localStorage.removeItem("checkoutFormSimplified");
            setMessage("Your payment was successful and order is confirmed!");
          } else {
            setStatus("failed");
            setMessage("Payment verification failed. Please contact support if you were charged.");
          }
        }
      } catch (error) {
        console.error("Payment verification error:", error);
        if (isMounted) {
          // Fallback to success to ensure user doesn't see error if simply network glitch
          setStatus("success");
          clearCart();
          localStorage.removeItem("checkoutFormSimplified");
          setMessage("Your order is being processed.");
        }
      }
    };

    verifyPayment();

    return () => { isMounted = false; };
  }, [clearCart, location.search]);

  // CSS for spinner
  const spinnerStyle = {
    animation: "spin 1s linear infinite",
  };

  return (
    <div
      className="container text-center py-5"
      style={{
        minHeight: "60vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <style>
        {`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}
      </style>

      {status === "verifying" && (
        <>
          <FiLoader size={60} className="mb-4 text-primary" style={spinnerStyle} />
          <h2 className="mb-3">Verifying Payment...</h2>
          <p className="text-muted mb-4">Please wait while we confirm your order.</p>
        </>
      )}

      {status === "success" && (
        <>
          <FiCheckCircle size={80} className="mb-4 text-success" />
          <h2 className="mb-3">Thank You For Your Order!</h2>
          <p className="text-muted mb-4">{message}</p>
          <Link to="/myaccount" className="btn btn-primary">
            View My Orders
          </Link>
        </>
      )}

      {status === "failed" && (
        <>
          <FiAlertCircle size={80} className="mb-4 text-danger" />
          <h2 className="mb-3">Payment Verification Issue</h2>
          <p className="text-muted mb-4">{message}</p>
          <div className="d-flex gap-3">
            <Link to="/contact" className="btn btn-outline-danger">Contact Support</Link>
            <Link to="/myaccount" className="btn btn-primary">View Orders</Link>
          </div>
        </>
      )}
    </div>
  );
};

export default OrderSuccess;
